import { selector } from 'recoil';
import { usingScenarioItemsState } from './skippedScenarioItemsState';
import { completedComponentIdsState, scenarioState } from './scenarioState';

export const scenarioCompletionState = selector({
  key: 'scenarioCompletionState',
  get({ get }) {
    const usingScenarioItems = get(usingScenarioItemsState)
      .filter(i => i.type === 'self');
    const completedComponentIds = get(completedComponentIdsState);
    const completedScenarioItems = get(scenarioState).items
      .filter(i => i.type === 'self')
      .filter(i => i.components.every((c) => completedComponentIds.includes(c.id)));
    return {
      totalCount: usingScenarioItems.length,
      completedCount: completedScenarioItems.length,
      completionRatio: completedScenarioItems.length / usingScenarioItems.length,
    };
  },
});
